<div class="support-title-bar">
  <div class="title-bar">
    <h1>
      <app-icon-button Icon="sms" [IsFillIcon]="true" Appearance="default" />
      <span>پشتیبانی</span>
    </h1>
    <h2>جهت ارائه خدمات بهتر خواهشمندیم نظرات خود را با ما در میان بگذارید.</h2>
  </div>
  <app-icon-button Icon="close" Appearance="accent" (click)="close.emit()" />
</div>
<form [formGroup]="form" (ngSubmit)="submitForm()">
  <textarea rows="6" placeholder="پیام" formControlName="text"></textarea>
  <re-captcha #captchaElem theme="dark" [siteKey]="siteKey" formControlName="recaptcha" />
  <app-button
    Type="submit"
    [FullWidth]="true"
    Text="ارسال"
    (click)="submitForm()"
    [Loading]="submitted()"
    [IsButton]="true"
  />
</form>
